var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ShowButtons)?_c('span',{staticClass:"spanBtnPrincipal"},[_vm._m(0),_c('div',{staticClass:"divBoxIcons"},[_c('ul',{staticClass:"boxIcons"},[_vm._t("bodyBtns")],2)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"reaction-btn-text btn btn-link text-secondary mb-0"},[_c('i',{staticClass:"fa fa-ellipsis-v text-xs",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }